"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupFeeFailureAction = exports.intervalUnit = exports.pricingModel = exports.tenureType = exports.status = void 0;
var status;
(function (status) {
    status["CREATED"] = "CREATED";
    status["INACTIVE"] = "INACTIVE";
    status["ACTIVE"] = "ACTIVE";
})(status || (exports.status = status = {}));
var tenureType;
(function (tenureType) {
    tenureType["REGULAR"] = "REGULAR";
    tenureType["TRIAL"] = "TRIAL";
})(tenureType || (exports.tenureType = tenureType = {}));
var pricingModel;
(function (pricingModel) {
    pricingModel["VOLUME"] = "VOLUME";
    pricingModel["TIERED"] = "TIERED";
})(pricingModel || (exports.pricingModel = pricingModel = {}));
var intervalUnit;
(function (intervalUnit) {
    intervalUnit["VOLUME"] = "VOLUME";
    intervalUnit["TIERED"] = "TIERED";
})(intervalUnit || (exports.intervalUnit = intervalUnit = {}));
var setupFeeFailureAction;
(function (setupFeeFailureAction) {
    setupFeeFailureAction["CONTINUE"] = "CONTINUE";
    setupFeeFailureAction["CANCEL"] = "CANCEL";
})(setupFeeFailureAction || (exports.setupFeeFailureAction = setupFeeFailureAction = {}));
